import { createTransform } from 'redux-persist'
import { AdminDashboardState, initialState } from './adminDashboardSlice'
import { RootState } from '../../types/RootState'

export const transformer = createTransform<
  AdminDashboardState,
  Omit<AdminDashboardState, 'error' | 'currentRequest'>,
  RootState
>(
  inboundState => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { error, currentRequest, ...persistedState } = inboundState
    return persistedState
  },
  outboundState => {
    const status: AdminDashboardState['status'] =
      outboundState.status === 'initial' ? outboundState.status : 'idle'
    return {
      ...outboundState,
      error: initialState.error,
      currentRequest: initialState.currentRequest,
      status,
    }
  },
  {
    whitelist: ['adminDashboard'],
  },
)
